import { useAuth } from '@/contexts/useAuth';
import { createComponentLogger } from '@/utils/logger';

const log = createComponentLogger('useSupabase', 'hooks');

/**
 * Hook to get the authenticated Supabase client
 * This ensures all database operations use the authenticated session
 */
export function useSupabase() {
  const auth = useAuth();
  
  if (!auth) {
    log.error('useSupabase called outside of AuthProvider');
    throw new Error('useSupabase must be used within an AuthProvider');
  }
  
  // Return the existing authenticated client from AuthContext
  // The client already has the session from auth state management
  // Creating new instances breaks session handling
  return auth.supabaseClient;
}

/**
 * Hook to get both the authenticated client and current session
 * Useful when you need both for operations
 */
export function useSupabaseWithSession() {
  const auth = useAuth();
  
  if (!auth) {
    log.error('useSupabaseWithSession called outside of AuthProvider');
    throw new Error('useSupabaseWithSession must be used within an AuthProvider');
  }
  
  return {
    supabase: auth.supabaseClient,
    session: auth.session,
    user: auth.user
  };
}